<!-- <ngx-extended-pdf-viewer
[src]="'/assets/pdf/CCMP.pdf'"
[useBrowserLocale]="true"
[textLayer]="true"
[showHandToolButton]="true" 
[showPresentationModeButton]="true"
  [showDownloadButton]="false">
</ngx-extended-pdf-viewer>   -->

<div class="section mt-3">
  <div class="px-3">
      <div class="theme-container">
          <mat-card class="p-0 o-hidden" fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="py-3 px-4">
              <h1 class="secondary-font primary-color mb-2 uppercase">Ayez une voiture sans avoir de voiture</h1>
              <p> Trouvez toujours une voiture près de chez vous, prête à partir.
                 Partez pour quelques heures ou quelques jours, et revenez à 
                 votre point de départ une fois terminé.</p>
          </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50">
                  <img src="assets/images/others/homme_volant.jpg" alt="about" class="mw-100 d-block">
              </div>
          </mat-card>
          <!--  -->
          <p><strong>Voitures en libre-service, disponibles 24h/24, à louer à l'heure ou à la journée</strong> </p>

          <mat-card class="p-0 o-hidden" fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="py-3 px-4">
              <mat-card class="p-0 o-hidden" fxLayout="row wrap">
                <p>Avant le départ</p>
              </mat-card>

              <!-- <h1 class="secondary-font primary-color mb-2">Depuis 2022, à votre service</h1>
              <p> Rendre la mobilité plus accessible, plus facile et plus responsable grâce
                  au partage est la mission qui nous anime. <strong>LocationSenegal</strong> est le premier site dédié à la location de voitures entre particuliers au Sénégal.
                  Pionnier de l'economie collaboratives, <strong>LocationSenegal</strong> propose à chacun de repenser son rapport à la
                  voiture en privilégiant son usage plutôt
                  que sa propriéte</p> -->
            

          </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50">
                  <img src="assets/images/others/homme_volant.jpg" alt="about" class="mw-100 d-block">
              </div>
          </mat-card>
          <!--  -->
          <mat-card class="p-0 o-hidden" fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50">
              <img src="assets/images/others/homme_volant.jpg" alt="about" class="mw-100 d-block">
          </div>
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="py-3 px-4">
              <h1 class="secondary-font primary-color mb-2">Depuis 2022, à votre service</h1>
              <p> Rendre la mobilité plus accessible, plus facile et plus responsable grâce
                  au partage est la mission qui nous anime. <strong>LocationSenegal</strong> est le premier site dédié à la location de voitures entre particuliers au Sénégal.
                  Pionnier de l'economie collaboratives, <strong>LocationSenegal</strong> propose à chacun de repenser son rapport à la
                  voiture en privilégiant son usage plutôt
                  que sa propriéte</p>
          </div>
              
          </mat-card>
      </div>
  </div>
</div>

<div fxLayout="row wrap" fxLayoutAlign="center">
  <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33" class="dimDIV">
    <div class=" px-3 py-2" >
      <div fxLayoutAlign="space-between center">
          <h3 class="primary-font">Adresse email</h3>
          <div class="icon-cercle2  display-flex align-center">
              <svg color="#FFF" viewBox="0 0 1024 1024"
                  style="display: inline-block; stroke: currentcolor; fill: currentcolor; width: 60px; height: 60px;">
                  <path
                      d="M167.784 281.233c7.015-18.32 24.765-31.329 45.553-31.329h597.334c20.787 0 38.535 13.008 45.553 31.329l-344.221 229.48-344.219-229.48zM91.434 297.983c-0.007 0.395-0.008 0.789-0.002 1.183v426.166c0 67.328 54.578 121.904 121.905 121.904h597.334c67.324 0 121.904-54.576 121.904-121.904v-426.166c0.007-0.387 0.004-0.774 0-1.162-0.358-67.022-54.799-121.243-121.904-121.243h-597.334c-67.098 0-121.535 54.21-121.903 121.222zM859.432 367.002v358.331c0 26.931-21.829 48.761-48.761 48.761h-597.334c-26.93 0-48.762-21.829-48.762-48.761v-358.331l327.142 218.094c12.284 8.188 28.288 8.188 40.572 0l327.142-218.094z">
                  </path>
              </svg>
          </div>
      </div>
      <p class="rufin-class2">Soyez assuré de recevoir tous les messages et notifications.</p>
      <p class="rufin-class">Vous avez confirmé cette adresse :
          <br />sdsdsfsf
      </p>
  </div>
  </div>
</div>
